import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { saveSession, errMsg } from '../services/api';
import Msg from '../components/Msg';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async e => {
    e.preventDefault();
    setMsg(null); setLoading(true);
    try {
      const res = await api.post('/api/auth/login', form);
      saveSession(res.data);
      navigate('/', { replace: true });
    } catch (err) {
      setMsg({ type: 'err', text: errMsg(err) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><img src="/icon.svg" alt="" width="52" height="52" /><h1>Buddies Manager</h1></div>
        <form onSubmit={submit}>
          <label>Email
            <input type="email" autoComplete="username" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </label>
          <label>Parolă
            <input type="password" autoComplete="current-password" required value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </label>
          <Msg msg={msg} />
          <button className="btn btn-primary btn-block" disabled={loading}>{loading ? 'Se conectează…' : 'Intră'}</button>
        </form>
      </div>
    </div>
  );
}
